import { getEmpresaAtiva } from "./auth";

//--- EMPRESA ATIVA --------------------------
function getEmpresaAtivaId() {
	return JSON.parse(getEmpresaAtiva()).id;
}

function getUrlRest(suffix = "") {
	return `${process.env.REACT_APP_API_URL}${suffix}`;
	//return `http://localhost/sistema_contratos_rest${suffix}`;
	//return `https://contratos.rest.j2solutions.com.br${suffix}`;
}

function mountUrl(url, props) {
	var params = [];
	if (props.page) params.push(`page=${props.page}`);
	if (props.busca) params.push(`busca=${props.busca}`);

	if (params.length === 0) return url;

	return `${url}?${params.join("&")}`;
}

//--- PERIODO ------------------------------------
//TODO Melhorar
const periodos = {
	1: "1 mês",
	3: "3 meses",
	6: "6 meses",
	12: "12 meses",
	18: "18 meses",
	24: "24 meses",
}

function getPeriodoOptions() {
	return Object.entries(periodos).map(([value, label]) => ({ value: Number(value), label }));
}

//--- TIPOS DE COBRANÇA --------------------------

const COBRANCA_TIPO_BOLETO = 1;
const COBRANCA_TIPO_PIX = 2;
const COBRANCA_TIPO_CARNE = 3;

const COBRANCA_TIPOS = {
	[COBRANCA_TIPO_BOLETO]: 'Boleto',
	[COBRANCA_TIPO_PIX]: 'PIX',
	[COBRANCA_TIPO_CARNE]: 'Carnê'
};

function getTiposCobrancaOptions() {
	return Object.entries(COBRANCA_TIPOS).map(([value, label]) => ({ value: Number(value), label }));
}

function getTipoCobrancaLabel(i) {
	return COBRANCA_TIPOS[i] ?? 'Desconhecido';
}

//--- STATUS DA COBRANÇA --------------------------

const COBRANCA_NOVA = 0;
const COBRANCA_PENDENTE = 10;
const COBRANCA_VENCIDA = 20;
const COBRANCA_CANCELADA = 50;
const COBRANCA_PAGA = 100;
const COBRANCA_BAIXADA = 110;

const COBRANCA_STATUS = {
	[COBRANCA_NOVA]: 'Nova',
	[COBRANCA_PENDENTE]: 'Pendente',
	[COBRANCA_VENCIDA]: 'Vencida',
	[COBRANCA_CANCELADA]: 'Cancelada',
	[COBRANCA_PAGA]: 'Paga',
	[COBRANCA_BAIXADA]: 'Baixada'
};

function getStatusCobrancaLabel(i) {
	return COBRANCA_STATUS[i] ?? 'Desconhecido';
}

export const AppHelper = {
	getEmpresaAtivaId,
	getUrlRest,
	mountUrl,
	getPeriodoOptions,
	getTiposCobrancaOptions,
	getTipoCobrancaLabel,
	getStatusCobrancaLabel,
	// TIPOS
	COBRANCA_TIPO_BOLETO,
	COBRANCA_TIPO_PIX,
	COBRANCA_TIPO_CARNE,
	// STATUS
	COBRANCA_NOVA,
	COBRANCA_PENDENTE,
	COBRANCA_VENCIDA,
	COBRANCA_CANCELADA,
	COBRANCA_PAGA,
	COBRANCA_BAIXADA,
};